<!-- eslint-disable -->
<template lang="pug">
    form.fields(action="javascript://", @submit="sendForm")
        .fields__element
            label.fields__label {{ $i18n.t('fields.fields_sort') }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="sort",
                :show-labels="false",
                :placeholder="$i18n.t('fields.fields_sortPlaceholder')",
                :searchable="false",
                track-by="by",
                label="label",
                v-model="form.sort"
            )
        .fields__element
            label.fields__label {{ $i18n.t('fields.fields_search') }}
            cs-search-input.fields__input(
                type="text",
                :placeholder="$i18n.t('fields.list_presentationThemeNamePlaceholder')",
                v-model="form.name"
                @search="sendForm"
            )
</template>

<script>
    /*eslint-disable*/
    import _ from 'lodash';
    import searchParamsStore from '../utils/searchParamsStore'
    import statusFieldMixin from '../utils/statusFieldMixin'

    export default {
        mixins: [searchParamsStore, statusFieldMixin],
        data() {
            return {
                sort: [
                        {label: this.$i18n.t('fields.list_sortName'), by: 'name'},
                        {label: this.$i18n.t('fields.list_sortTime'), by: 'created_at'},
                    ],
                form: {
                    sort: {label: this.$i18n.t('fields.list_sortTime'), by: 'created_at'},
                    name: '',
                }
            }
        },
        watch: {
            '$route.query' (val) {
                if (_.isEmpty(val)) {
                    this.form = _.cloneDeep(this.localSearchParams) || {
                        sort: null,
                        name: '',
                    };
                }
            },
            'form.name'() {
                this.updateList()
            },
            'form.sort'() {
                this.updateList()
            },
        },
        methods: {
            sendForm() {
                this.$emit('search',
                    Object.assign({}, this.form, {
                        sort: _.has(this.form, 'sort.by') ? this.form.sort.by : null
                    })
                );
            },
            resetResults() {
                this.$emit('search', this.form = {
                    sort: null,
                    name: ''
                });
            },
            updateList: _.debounce(function() {
                this.sendForm()
            }, 1000)
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../assets/sass/fields/fields.scss";
</style>
